/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('store.parlogis-filter-toggle', function (el) {
        var dialog = document.querySelector(el.dataset.dialog);
        var toggle = MoyaContainer.get('core.toggle').create(el, dialog, 'storeParalogisFilterToggle', {
            closeOthers: true,
        });
        MoyaContainer.set('store.paralogis-filter-toggle', toggle);
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
